module.exports = __webpack_public_path__ + "img/382.2ce3aa14.png";